import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Membership from "./routes/Membership";
import Overview from "./routes/Overview";
export default store => ({
  path: ":yearGroupId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-yearGroupManager" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Overview(store), Membership(store)],
});
